import { StyleSheet, View } from 'react-native'
import React from 'react'
import Overlay from '@components/Overlay/Overlay'
import { PrimaryText } from '@components/Common/PrimaryText/PrimaryText'
import PrimaryButton from '@components/Buttons/PrimaryButton/PrimaryButton'
import { Box } from '@mui/material'
import useMediaQuery from '@hooks/useMediaQuery'
import donationIcon from '@assets/misc/donation.png'
import commentIcon from '@assets/misc/comment.png'
import compassIcon from '@assets/misc/compass.png'
import rayzeIcon from '@assets/rayze.png'
import calendarIcon from '@assets/misc/calendar.png'
import announcementIcon from '@assets/misc/announcement.png'
import addUserIcon from '@assets/misc/addUser.png'
import { WelcomeProps } from '@Interfaces/Component/WelcomeInterface'

const Welcome: React.FC<WelcomeProps> = ({ onPress }) => {
  const { getResponsiveValue } = useMediaQuery()
  return (
    <Overlay contentContainerStyle={styles.container}>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        maxWidth={592}
        py={44}
        backgroundColor="white"
        borderRadius="15px"
        justifyContent="center"
        alignItems="center"
      >
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          <img
            src={donationIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />
          <img
            src={commentIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />
          <img
            src={compassIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />

          <img
            src={rayzeIcon}
            width={getResponsiveValue({
              sm: 106,
              xs: 40,
            })}
          />

          <img
            src={calendarIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />
          <img
            src={announcementIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />
          <img
            src={addUserIcon}
            width={getResponsiveValue({
              sm: 50,
              xs: 24,
            })}
          />
        </View>

        <PrimaryText fontSize={24} fontWeight={900} style={{ marginTop: 17, marginBottom: 7 }}>
          Welcome
        </PrimaryText>

        <PrimaryText fontSize={16}>Donate, Volunteer, and Give Back</PrimaryText>

        <PrimaryButton
          title="Get Started"
          style={{ marginTop: 36, minWidth: 148, marginBottom: 0 }}
          onPress={onPress}
        />
      </Box>
    </Overlay>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
  },
  centered: {
    width: 592,
    height: 362,
    backgroundColor: 'white',
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default Welcome
